import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const PackagesLayout = () => {
  const navList = useNav();
  let { packagesBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={packagesBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default PackagesLayout;
